import { Chip, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
    chip: {
        width: "84px",
    },
}));

interface Props {
    count: number;
    onClick: () => void;
    itemLabel: string;
    color?: "primary" | "secondary";
}

export function StatsCountIndicator({
    count,
    onClick,
    itemLabel,
    color = "primary",
}: Props) {
    const classes = useStyles();

    const label = count === 0
        ? `No ${itemLabel}s`
        : count === 1
            ? `1 ${itemLabel}`
            : `${count} ${itemLabel}s`;

    return (
        <Chip
            variant="outlined"
            color={color}
            label={label}
            className={classes.chip}
            onClick={count === 0 ? undefined : onClick}
        />
    );
}
